export const ERC20ABI = require('./erc20.json')
export const CPGABI = require('./CPG.json')
